import { render, staticRenderFns } from "./co-creation-terms-of-use.vue?vue&type=template&id=2463a92f"
import script from "./co-creation-terms-of-use.vue?vue&type=script&lang=js"
export * from "./co-creation-terms-of-use.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotInternal: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Templates/Internal/Internal.vue').default})
